var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"User"}},[_c('div',{staticClass:"User"},[_c('div',{staticClass:"user_container"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }